module.exports = __webpack_public_path__ + "img/default_lecture.88289b01.jpg";